import { COMPARISON_PERIOD } from "~/store/utils/dateTimeUtils";
import { DATETIME_PERIODS } from "~/store/utils/dateTimeUtils";

export enum ReportRunStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REJECTED = "REJECTED",
}

interface ReportConfig {
  frequency: "once" | "d" /*daily */ | "w" /*weekly*/ | "m" /* monthly */;
  currentPeriod: DATETIME_PERIODS;
  comparisonPeriod: COMPARISON_PERIOD;
  timezone: string;
  currency: string;
  reportingDelay?: number;
  // for reports where frequency === 'once'
  fromDate?: Date;
  toDate?: Date;
}

export type AMCAdditionalFieldValues = Record<string, string | string[]>;

type AMCScheduledReport = {
  _id: string;
  organisationId: string;
  userId: string;
  mid: string;
  queryType: string; // Mongo id
  reportName: string;
  reportConfig: ReportConfig;
  description: string;
  reportRecipients: string[];
  parameterValues?: AMCAdditionalFieldValues;
  lastRunDate: Date | null;
  lastRunStatus: ReportRunStatus;
  nextRunDate: Date | null;
  isActive: boolean;
  createdAt: Date;
  historicalReportsScheduled: boolean;
  historicalReportsScheduledTill?: Date;
  allHistoricalReportsFetched: boolean;
  workflowId: string | null;
  scheduleId: string | null;
};

export type PrunedAMCScheduledReport = Omit<
  AMCScheduledReport,
  "organisationId" | "workflowId" | "workflowExecutionId" | "scheduleId"
>;
